export const SIDES_MIN = 3

export const SIDES_MAX = 100

export const SIDES_RANGE_ERROR = 'Value: 3-100'

export const INSET_MIN = 0

export const INSET_MAX = 100

export const INSET_RANGE_ERROR = 'Value: 0-100'

export const SIDES_PRESET_VALUES = [4, 8, 24, 48] as const

export const INSET_PRESET_VALUES = [0, 10, 20, 40, 80] as const
